/**
 * Custom GPT Navbar Component
 * Navigation bar for Custom GPT pages with links to Chat and Custom GPTs
 */

import { useNavigate, useLocation } from 'react-router-dom'
import { Button } from '../ui/button'
import { MessageSquare, Bot, Home } from 'lucide-react'

export function CustomGPTNavbar() {
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/')
  }

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-light-border/50 dark:border-slate-800/50 bg-light-surface/95 dark:bg-slate-950/95 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo/Brand */}
          <div 
            className="flex items-center space-x-2 cursor-pointer"
            onClick={() => navigate('/chat')}
          >
            <div className="text-xl font-bold bg-gradient-to-r from-brand-blue to-blue-600 bg-clip-text text-transparent">
              AIRA
            </div>
          </div>

          {/* Navigation Links */}
          <div className="flex items-center gap-1 sm:gap-2">
            <Button
              variant={isActive('/chat') ? 'default' : 'ghost'}
              size="sm"
              onClick={() => navigate('/chat')}
              className={isActive('/chat') ? 'bg-brand-blue hover:bg-brand-blue-hover text-white' : ''}
              title="Switch to AIRA"
            >
              <MessageSquare className="w-4 h-4 sm:mr-2" />
              <span className="hidden sm:inline">Switch to AIRA</span>
            </Button>
            <Button
              variant={isActive('/playbooks') ? 'default' : 'ghost'}
              size="sm"
              onClick={() => navigate('/playbooks')}
              className={isActive('/playbooks') ? 'bg-brand-blue hover:bg-brand-blue-hover text-white' : ''}
              title="Playbooks"
            >
              <Bot className="w-4 h-4 sm:mr-2" />
              <span className="hidden sm:inline">Playbooks</span>
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/')}
              title="Home"
            >
              <Home className="w-4 h-4 sm:mr-2" />
              <span className="hidden sm:inline">Home</span>
            </Button>
          </div>
        </div>
      </div>
    </nav>
  )
}
